/**
 * Created by olga on 09.06.2025
 */

Mission.TYPE_LEVEL_MASTERY = 102;

Mission.REGISTRATIONS.set(Mission.TYPE_LEVEL_MASTERY, () => ({
    available: cleverapps.config.availables.LEVEL_MASTERY_MISSION,
    name: "LevelMastery",
    view: LevelMasteryWindow,
    stages: bundles.level_mastery_stages.jsons.stages_config_json.getJson(),
    startWindow: GuideWindow,
    guideWindow: {
        name: "LevelMasteryGuideWindow",
        bundle: bundles.levelmastery_guide_window
    },
    nudgeWindow: undefined,
    schedule: cleverapps.config.type === "merge2" ? "MON-THU" : "MON-FRI",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    bundle: "levelmastery",
    sideBarJson: cleverapps.config.type === "merge2" ? bundles.sidebar.jsons.levelmastery_icon_json : false,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.levelmastery_row_prefab_json, { mission: row.data.mission });
    } : undefined,
    logic: LevelMastery
}));
